let queue = {};

const Publish = (event, data) => {
  const currentQueue = queue[event];
  if (typeof currentQueue === "undefined") {
    return false;
  }
  while (currentQueue.length > 0) {
    currentQueue.shift()(data);
  }
  return true;
};

const Subscribe = (event, callback) => {
  if (typeof queue[event] === "undefined") {
    queue[event] = [];
  }
  queue[event].push(callback);
};

export { Publish, Subscribe };
